





























































































































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import {
  LMap,
  LImageOverlay,
  LMarker,
  LPolyline,
  LControlZoom,
  LControl,
  LIconDefault,
  LIcon,
  LTooltip
} from "vue2-leaflet";
import { CRS } from "leaflet";
import CircleComponent from "@/components/common/figures/CircleComponent.vue";
import LeafletPopupComponent from "@/components/packages/leaflet/LeafletPopupComponent.vue";
import isOverThreshold from "@/typescript/lib/common/is_over_threshold";
import { getCircleColor } from "@/typescript/components/common/figures/circle_component/functions";
import { getWarningImage } from "@/typescript/lib/common/get_warning_image";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";
import { getEquipmentsMeasurementApi } from "../../../typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { Moment } from "@/typescript/lib/common/moment";
import {
  lMapStyle,
  MapObject,
  LatLng,
  MapMode
} from "@/typescript/packages/leaflet/index";
import { Sensor } from "@/typescript/models/sensor/types";
import { SensorDiagramsInfo } from "../../../typescript/pages/sensor_diagrams/types";
export { lMapStyle, MapObject, LatLng, Sensor, MapMode, SensorDiagramsInfo };

@Component({
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPolyline,
    LControl,
    LControlZoom,
    LIconDefault,
    LTooltip,
    LIcon,
    CircleComponent,
    LeafletPopupComponent
  }
})
export default class LeafletImageComponent extends Vue {
  $refs!: {
    map: MapObject;
    mapping_marker: LMarker;
  };
  @Prop()
  bounds!: number[][];

  @Prop()
  lMapStyle!: lMapStyle;

  @Prop()
  imagePath!: string;

  @Prop({
    default: []
  })
  selectableSensors!: SensorDiagramsInfo[];

  @Prop({
    default: []
  })
  mappingSensors!: SensorDiagramsInfo[];

  @Prop()
  mapMode!: MapMode;

  crs = CRS.Simple;
  minZoom: number = -1;
  lMapOptions = {
    attributionControl: false,
    zoomControl: false
  };
  provMarker: LatLng = {};
  isSensorSelected: boolean = false;
  selectedSensor: SensorDiagramsInfo | {} = {};

  addMarker(event) {
    if (this.mapMode !== "edit") return;
    if (this.isSensorSelected) {
      this.isSensorSelected = false;
      return;
    }
    this.provMarker = { lat: event.latlng.lat, lng: event.latlng.lng };
    this.$refs.map.mapObject.setView(
      [this.provMarker.lat!, this.provMarker.lng!],
      0
    );
    this.toggleMappingMarker(true);
  }

  @Emit()
  mappingSensor(sensor: SensorDiagramsInfo) {
    // 配置時に座標がズレるため、ズレを修正するために + 10, -20 する
    sensor.positionX = (this.provMarker.lat as number) + 10;
    sensor.positionY = (this.provMarker.lng as number) - 20;
    this.provMarker = {};
    this.$refs.map.mapObject.setView([sensor.positionX, sensor.positionY], 0);
    this.isSensorSelected = true;
    return sensor;
  }

  isOverThreshold(ctTemp: number, thLow: number, thHigh: number): boolean {
    return isOverThreshold(ctTemp, thLow, thHigh);
  }

  @Emit()
  removeSensor(sensor: SensorDiagramsInfo): SensorDiagramsInfo {
    return sensor;
  }

  // マッピング中のセンサをセンサリストから選択されたセンサに置き換える
  @Emit()
  remappingSensor(sensor: SensorDiagramsInfo): SensorDiagramsInfo[] {
    const selectedSensor = this.selectedSensor as SensorDiagramsInfo;
    sensor.positionX = selectedSensor.positionX;
    sensor.positionY = selectedSensor.positionY;
    this.selectedSensor = {};
    const remappingSensors = this.mappingSensors.filter(
      s => s.equipmentId !== selectedSensor.equipmentId
    );
    remappingSensors.push(sensor);
    return remappingSensors;
  }

  toggleMappingMarker(isVisible: boolean) {
    if (!this.$refs["mapping_marker"]) return;
    this.$refs.mapping_marker.setVisible(isVisible);
  }

  async openPopup(sensor: SensorDiagramsInfo) {
    this.toggleMappingMarker(false);
    this.$refs.map.mapObject.setView([sensor.positionX, sensor.positionY], 0);
    this.selectedSensor = sensor;
    const apiDatetimeFormat = "YYYYMMDDHHmmss";
    const equipment = await getEquipmentsMeasurementApi({
      equipment_id: sensor.equipmentId,
      since: new Moment(apiDatetimeFormat).getStartOf("day"),
      until: new Moment(apiDatetimeFormat).getEndOf("day")
    });
    // measurementData は格納順が降順日付で返却されるため、逆順にする
    // もし、パフォーマンスに影響があるなら、配列を用意して for 文で再起処理をした方がよい
    equipment.measurement_data = equipment.measurement_data.reverse();
    this.$set(this.selectedSensor, "graphData", [
      {
        data: equipment.measurement_data.map(m => Number(m.temperature))
      }
    ]);
    this.$set(this.selectedSensor, "alertAllCount", equipment.alerts.length);
  }

  zoomIn() {
    this.$refs.map.mapObject.setZoom(this.$refs.map.mapObject.getZoom() + 1);
  }

  zoomOut() {
    this.$refs.map.mapObject.setZoom(this.$refs.map.mapObject.getZoom() - 1);
  }

  isDef(temp: string | "DEF") {
    return temp === "DEF";
  }

  hasErrorOrOverThreshold(
    temp: string,
    lowerLimit: number,
    upperLimit: number
  ): boolean {
    return (
      isNaN(Number(temp)) ||
      isOverThreshold(Number(temp), lowerLimit, upperLimit)
    );
  }

  getCircleColor(upper: number) {
    return getCircleColor(upper);
  }

  getWarningImage(status: 0 | 1 | 2) {
    return getWarningImage(status);
  }

  getCategoryImage(iconKind: number, status: "on" | "off") {
    return getEquipmentIcon(iconKind, status);
  }
}
